var _Defs, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Defs, G, Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgZipFile(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 400 400",
    id: "zip-file_svg__svg27",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, {
    id: "zip-file_svg__defs4"
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    id: "zip-file_svg__xxx-word"
  }, /*#__PURE__*/React.createElement(Path, {
    className: "zip-file_svg__cls-1",
    d: "M325 105h-75a5 5 0 01-5-5V25a5 5 0 1110 0v70h70a5 5 0 010 10z",
    id: "zip-file_svg__path8"
  }), /*#__PURE__*/React.createElement(Path, {
    className: "zip-file_svg__cls-1",
    d: "M325.684 200.782c-2.761 0-3.69.954-3.746-1.807L320 102.07 247.93 30H100c-11.046 0-19.915 8.955-20 20l-1.14 147.429c-.022 2.761-.414 4.316-3.176 4.316-2.761 0-5.684 2.778-5.684.017V50c0-16.569 13.431-30 30-30h150a5 5 0 013.54 1.46l75 75A5 5 0 01330 100v97.492c0 2.762-1.554 3.29-4.316 3.29z",
    id: "zip-file_svg__path10"
  }), /*#__PURE__*/React.createElement(Path, {
    className: "zip-file_svg__cls-1",
    d: "M300 380H100c-16.569 0-29.625-5.056-29.625-21.624v-2.388c0-6.666 10.438-6.732 10.512-.066l.025 2.29C81.034 369.257 88.954 370 100 370h200c11.046 0 20.228-1.2 20.228-12.246v-1.188c0-6.667 10.408-8.147 10.442-1.48l.014 2.668C330.77 374.322 316.57 380 300 380z",
    id: "zip-file_svg__path12"
  }), /*#__PURE__*/React.createElement(Path, {
    className: "zip-file_svg__cls-1",
    d: "M325 359.361H75c-16.569 0-30-13.431-30-30v-76.83c0-12.038-7.399-58.74 36.465-60.348 8.454-.31 17.151-.739 28.465-.76l69.375-.134 141.38-.093c39.643.503 34.276 46.521 34.325 62.995v75.17c0 16.573-13.438 30.006-30.01 30zm-220.289-157.9c-7.025.04-13.556.673-19.23.648-30.926-.141-30.508 23.553-30.481 50.422v76.83c0 11.046 8.954 20 20 20h250c11.046 0 20-8.954 20-20v-75.17c-.032-10.985 5.71-55.951-28.938-52.456l-145.113-.73z",
    id: "zip-file_svg__path18"
  }), /*#__PURE__*/React.createElement(Path, {
    className: "zip-file_svg__cls-1",
    d: "M170.795 315.59v17.393H81.56v-15.922l61.89-80.077H85.906v-16.007h83.124v16.007l-61.12 78.606z",
    id: "zip-file_svg__path20",
    strokeWidth: 2.181
  }), /*#__PURE__*/React.createElement(Path, {
    className: "zip-file_svg__cls-1",
    d: "M209.437 332.983h-21.754V220.977h21.754z",
    id: "zip-file_svg__path22",
    strokeWidth: 2.181
  }), /*#__PURE__*/React.createElement(Path, {
    className: "zip-file_svg__cls-1",
    d: "M257.722 332.983h-21.754V220.977h49.416q21.143 0 31.353 9.894a37.057 34.387 0 01-.838 48.21 39.592 36.74 0 01-28.025 9.516h-30.152zm0-61.695h25.738q10.074 0 15.393-4.6a17.159 15.923 0 005.297-12.226 18.11 16.805 0 00-4.912-11.806q-4.912-4.916-17.725-4.916h-23.791z",
    id: "zip-file_svg__path24",
    strokeWidth: 2.181
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M146.635 35.114h-39.54v35.68h39.54v67.13h-39.54v35.669h21.144c35.265-.569-15.69.66 32.54-.124h-.435v-54.755h36.303v-35.68h-36.303V29.61l2.761-.806c-15.655.072-16.525-9.745-16.47 6.31z",
    id: "zip-file_svg__path3389-4",
    strokeWidth: 9.704
  }))));
}
export default SvgZipFile;